import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, obj=authed, false=not authed

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password, portal) => {
    const { data } = await api.post("/auth/login", { email, password, portal });
    setUser(data);
    return data;
  };

  const registerCompany = async (body) => {
    const { data } = await api.post("/auth/register-company", body);
    setUser(data);
    return data;
  };

  const registerVendor = async (body) => {
    const { data } = await api.post("/auth/register-vendor", body);
    setUser(data);
    return data;
  };

  const acceptInvite = async (token, password) => {
    const { data } = await api.post("/auth/accept-invite", { token, password });
    setUser(data);
    return data;
  };

  const forgotPassword = async (email) => {
    const { data } = await api.post("/auth/forgot-password", { email });
    return data;
  };

  const resetPassword = async (token, password) => {
    const { data } = await api.post("/auth/reset-password", { token, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, registerCompany, registerVendor, acceptInvite, forgotPassword, resetPassword, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
